import { cx } from '@linaria/core';
import { useRef, useEffect } from 'react';
import { resets } from '@ui/css';
import { typesetKatex } from '@utils/common';
import { useChangeEffect, Chevron } from '@utils/react';
import { TabUnderline } from '../../utils/TabUnderline.LEGACY/index.js';
import { useScrollState } from './hook.scroll-state.js';
import { tabGroup, separator, tabWrapper, scrollButton, scrollContentWrapper } from './tablist.style.js';
export { tablistSelectors } from './tablist.style.js';
import { handleTablistKeydownEvent } from './util.key-down.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Tablist(props) {
  const tabWrapperRef = useRef(null);
  const {
    isAtLeft,
    isAtRight
  } = useScrollState(tabWrapperRef);
  const activeItemIndex = props.tabs.findIndex(tab => tab.id === props.selectedTabId);
  useEffect(() => {
    typesetKatex(tabWrapperRef);
  }, []);
  useChangeEffect(() => {
    const activeButton = tabWrapperRef.current?.querySelector(`button[aria-selected="true"]`);
    const tabWrapper = tabWrapperRef.current;
    if (!activeButton || !tabWrapper) {
      return;
    }
    tabWrapper.scrollTo({
      left: activeButton.offsetLeft - tabWrapper.clientWidth / 2 + activeButton.clientWidth / 2,
      behavior: "smooth"
    });
  }, [activeItemIndex]);
  return /*#__PURE__*/jsxs("div", {
    className: cx(resets.rootCls, scrollContentWrapper, props.className),
    children: [/*#__PURE__*/jsxs("div", {
      ref: tabWrapperRef,
      className: cx(tabWrapper, props.withSeparators && "withSeparators"),
      role: "tablist",
      "aria-label": props.label,
      onKeyDown: handleTablistKeydownEvent,
      children: [props.tabs?.map((it, index) =>
      /*#__PURE__*/
      // eslint-disable-next-line jsx-a11y/role-supports-aria-props
      jsxs("button", {
        className: tabGroup,
        "aria-selected": it.id === props.selectedTabId ? "true" : "false",
        "aria-controls": `${props.baseId}-panel-${it.id}`,
        id: `${props.baseId}-tab-${it.id}`,
        tabIndex: it.id === props.selectedTabId ? 0 : -1,
        onClick: () => props.onTabClick(it.id)
        // Firefox requires a style attribute of userSelect to be set for
        // polly to work correctly.
        // See ADO #108360
        ,
        style: {
          userSelect: "auto"
        },
        children: [/*#__PURE__*/jsx("span", {
          children: it.title
        }), props.withSeparators && index !== props.tabs.length - 1 && /*#__PURE__*/jsx("span", {
          className: separator,
          "aria-hidden": true,
          children: /*#__PURE__*/jsx(Chevron, {
            size: 6,
            lineWidth: 1.5
          })
        })]
      }, it.id)), /*#__PURE__*/jsx(TabUnderline, {
        parentElementRef: tabWrapperRef,
        activeItemIndex: activeItemIndex,
        separatorOffset: props.withSeparators ? 24 : 0
      })]
    }), /*#__PURE__*/jsx("button", {
      className: cx(scrollButton, "left", isAtLeft && "hidden"),
      "aria-hidden": true,
      onClick: () => scrollInDirection(tabWrapperRef, "left"),
      tabIndex: -1,
      children: /*#__PURE__*/jsx(Chevron, {
        inversed: true,
        size: 11
      })
    }), /*#__PURE__*/jsx("button", {
      className: cx(scrollButton, "right", isAtRight && "hidden"),
      "aria-hidden": true,
      onClick: () => scrollInDirection(tabWrapperRef, "right"),
      tabIndex: -1,
      children: /*#__PURE__*/jsx(Chevron, {
        size: 11
      })
    })]
  });
}
const scrollInDirection = (tabWrapperRef, direction) => {
  const tabWrapper = tabWrapperRef.current;
  if (!tabWrapper) {
    return;
  }
  tabWrapper?.scrollTo(direction === "left" ? {
    left: tabWrapper.scrollLeft - tabWrapper.clientWidth,
    behavior: "smooth"
  } : {
    left: tabWrapper.scrollLeft + tabWrapper.clientWidth,
    behavior: "smooth"
  });
};

export { Tablist };
//# sourceMappingURL=tablist.js.map
